import { Breadcrumbs, Typography } from "@mui/material";
import { Link } from "react-router-dom";


/**
 * 
 * @param {object} props E.g { trail: [{to: '/', label: 'Home'}, ...]} 
 * @returns 
 */
export default function HikoBreadcrumbs({trail}) {

    if (!trail?.length || !Array.isArray(trail)) {
        return null
    }
    return (
        <Breadcrumbs sx={{mb:2}}>
            {
                trail.map((crumb, index) => {
                    return (
                        crumb.to
                        ?
                        <Link key={crumb.label || index} to={crumb.to}>{crumb.label} </Link>
                        :
                        <Typography key={crumb.label || index}>{crumb.label}</Typography>
                    )
                })
            }
        </Breadcrumbs>
    )
}